/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactsTimeseriesPoint } from './ContactsTimeseriesPoint.js';
import {
    ContactsTimeseriesPointFromJSON,
    ContactsTimeseriesPointFromJSONTyped,
    ContactsTimeseriesPointToJSON,
} from './ContactsTimeseriesPoint.js';

/**
 * 
 * @export
 * @interface GetContactsTimeseriesResponse
 */
export interface GetContactsTimeseriesResponse {
    /**
     * 
     * @type {Array<ContactsTimeseriesPoint>}
     * @memberof GetContactsTimeseriesResponse
     */
    data?: Array<ContactsTimeseriesPoint>;
    /**
     * 
     * @type {number}
     * @memberof GetContactsTimeseriesResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactsTimeseriesResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactsTimeseriesResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetContactsTimeseriesResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetContactsTimeseriesResponse interface.
 */
export function instanceOfGetContactsTimeseriesResponse(value: object): boolean {
    return true;
}

export function GetContactsTimeseriesResponseFromJSON(json: any): GetContactsTimeseriesResponse {
    return GetContactsTimeseriesResponseFromJSONTyped(json, false);
}

export function GetContactsTimeseriesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactsTimeseriesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ContactsTimeseriesPointFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetContactsTimeseriesResponseToJSON(value?: GetContactsTimeseriesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ContactsTimeseriesPointToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

